import React, { useEffect, useState } from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import MemberTypeForm from '../../../components/forms/MemberTypeForm';
import { useMemberTypeById, useUpdateMemberType } from '../../../hooks/useMemberTypeApi';
import { useNavigate, useParams } from 'react-router-dom';
import Card from '../../../components/common/Card';
import { MemberTypeDTO } from '../../../services/apiClient';

const MemberTypeEdit: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const { data: entityData, isLoading } = useMemberTypeById(id!);
  const updateMemberType = useUpdateMemberType();
  const navigate = useNavigate();

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Member Types', href: '/admin/membertypes' },
    { label: 'Edit', href: '#' },
  ];

  const handleSubmit = async (data: any) => {
    try {
      await updateMemberType.mutateAsync({ id: id!, data });
      navigate('/admin/membertypes');
    } catch (error) {
      console.error('Error updating MemberType:', error);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/membertypes"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
      requiredPermission='Settings.MemberType.Edit'
    >
        {entityData ? (
          <MemberTypeForm
            initialValues={entityData}
            onSubmit={handleSubmit}
            onCancel={() => navigate('/admin/membertypes')}
          />
        ) : (
          <p>Loading...</p>
        )}
    </AdminLayout>
  );
};

export default MemberTypeEdit;